export default __webpack_public_path__ + "static/media/pexels-ivan-samkov-4989167.8f736390.jpg";